// ----------------------------------------------------------------------------
// Component: Product Recommendations
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/card/card';


// -------------------------------------
// Variables
// -------------------------------------

// Selectors
const RECOMMENDATIONS_SELECTOR = '.product-recommendations';

// Style includes
import './_product-recommendations.scss';


// -------------------------------------
// Helpers
// -------------------------------------

const initProductRecommendations = () => {
    const productRecommendations = document.querySelectorAll(RECOMMENDATIONS_SELECTOR);

    productRecommendations.forEach((productRecommendation) => {
        loadRecommendations(productRecommendation);
    });
};

const loadRecommendations = (section) => {
    const url = section.dataset.url;

    fetch(url)
        .then(response => response.text())
        .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector(RECOMMENDATIONS_SELECTOR);

            if (recommendations && recommendations.innerHTML.trim().length) {
                section.innerHTML = recommendations.innerHTML;
            }
        })
        .catch(e => {
            console.error(e);
        });
};


// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    initProductRecommendations();
});
